import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { usePortalLoad } from "@/lib/portalApi";
import { fdate } from "@/lib/api";
import { PageHeader } from "@/components/common";

export function StageTracker({ stages, stage, testId = "job-tracker" }) {
  return (
    <ol className="flex w-full items-center gap-1" data-testid={testId}>
      {stages.map((s, i) => (
        <li key={s} className="flex-1" title={s}>
          <div className={`h-1.5 rounded-full ${stage !== null && i <= stage ? "" : "bg-slate-200"}`} style={stage !== null && i <= stage ? { background: "var(--brand)" } : undefined} />
        </li>
      ))}
    </ol>
  );
}

export default function PortalJobs() {
  const [d] = usePortalLoad("/jobs");
  if (!d) return null;
  return (
    <>
      <PageHeader title="Your jobs" subtitle="Live progress of everything we're printing for you." />
      <div className="space-y-3" data-testid="portal-jobs-list">
        {d.jobs.length === 0 && <p className="po-card p-6 text-sm text-slate-400">No jobs yet. Once a quote is accepted, its job appears here.</p>}
        {d.jobs.map((j) => (
          <Link key={j.id} to={`/portal/jobs/${j.id}`} data-testid={`portal-job-${j.number}`} className="po-card block space-y-3 p-5 transition-colors hover:border-slate-400 fade-up">
            <div className="flex flex-wrap items-center gap-3">
              <div className="min-w-0 flex-1"><div className="font-semibold text-slate-900">{j.title}</div><div className="text-xs text-slate-500">{j.number} · qty {j.quantity?.toLocaleString()}{j.due_date && ` · due ${fdate(j.due_date)}`}</div></div>
              <span data-testid={`portal-job-label-${j.number}`} className="rounded-full border px-3 py-1 text-xs font-semibold" style={{ borderColor: "var(--brand)", color: "var(--brand)" }}>{j.label}</span>
              <ChevronRight className="h-4 w-4 text-slate-400" />
            </div>
            <StageTracker stages={d.stages} stage={j.stage} testId={`portal-job-tracker-${j.number}`} />
          </Link>
        ))}
      </div>
    </>
  );
}
